<div [attr.id]="idProp">
    <div class="modal-header">
        <h4 class="modal-title">{{ "user.create.responsibleFor" | translate }}</h4>
        <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
    </div>
    <div class="modal-body">
        <adaa-data-table
            [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USER_CONCERNED_ENTITIES_LIST"
            [isLocalData]="true"
            [localData]="entities"
            [enableActionsCell]="false"
            [enableAdd]="false"
            [enableSelection]="true"
            [multiSelection]="selectedResponsiblities"
            [selectionId]="'entityId'"
            (getRowData)="rowSelected = $event"
        ></adaa-data-table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
    </div>
</div>
